import { render, staticRenderFns } from "./_base-module-tabs.vue?vue&type=template&id=2f43db9e&"
import script from "./_base-module-tabs.vue?vue&type=script&lang=js&"
export * from "./_base-module-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports